"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableBillingPeriod = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../../../../shared/core");
var IconHeader_1 = require("../../../../../../../shared/core/components/IconHeader");
var analytics_subjects_1 = require("../../../../../analytics-subjects");
var ExpandableBillingPeriod_styled_1 = require("./ExpandableBillingPeriod.styled");
exports.ExpandableBillingPeriod = (0, react_1.forwardRef)(function (_a, ref) {
    var _b;
    var children = _a.children, title = _a.title, subtitle = _a.subtitle, total = _a.total, id = _a.id, _c = _a.expanded, expanded = _c === void 0 ? false : _c, rest = __rest(_a, ["children", "title", "subtitle", "total", "id", "expanded"]);
    var _d = __read((0, react_1.useState)(expanded), 2), isExpanded = _d[0], setIsExpanded = _d[1];
    var _e = (0, core_1.useComponents)(), Icon = _e.Icon, Card = _e.Card;
    return (react_1.default.createElement(Card, { "data-testid": "billing-period-card" },
        react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_PERIOD_EXPANDED, properties: (_b = { isExpanded: isExpanded }, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
            react_1.default.createElement(ExpandableBillingPeriod_styled_1.StyledExpandableBillingPeriodButton, __assign({ onClick: function () { return setIsExpanded(!isExpanded); }, "aria-expanded": isExpanded, "aria-controls": id, "data-testid": "billing-period-button", type: "button" }, rest, { ref: ref }),
                react_1.default.createElement(ExpandableBillingPeriod_styled_1.StyledExpandableBillingPeriodHeaderContent, null,
                    react_1.default.createElement(IconHeader_1.IconHeader, { icon: "billing", heading: title, subtitle: subtitle }),
                    react_1.default.createElement(ExpandableBillingPeriod_styled_1.StyledExpandableBillingPeriodTotal, null, total)),
                react_1.default.createElement(ExpandableBillingPeriod_styled_1.StyledExpandableBillingPeriodButtonIcon, null,
                    react_1.default.createElement(Icon, { name: isExpanded ? 'chevron-up' : 'chevron-down' })))),
        isExpanded && (react_1.default.createElement(ExpandableBillingPeriod_styled_1.StyledExpandableBillingPeriodPanel, { id: id }, children))));
});
